function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import ConditionalWrapper from "../../../helpers/ConditionalWrapper";
var CaretDownSvg = function CaretDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m11.284 8.991-4.526 5.16a.675.675 0 0 1-1.042 0 .926.926 0 0 1 0-1.189L9.72 8.397 5.716 3.832a.926.926 0 0 1 0-1.189.675.675 0 0 1 1.042 0l4.526 5.16a.901.901 0 0 1 .216.594c0 .215-.072.43-.216.594Z",
    fill: "#000"
  }));
};
CaretDownSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
};
import IconAtm from "../../atoms/IconAtm";
import StepAtm from "../../atoms/StepAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
var StepsMol = function StepsMol(_ref) {
  var steps = _ref.steps;
  return /*#__PURE__*/React.createElement(FlexContainerOrg, {
    gapSpace: 0.5,
    alignItems: "center"
  }, steps.map(function (step, index) {
    var isCompleted = step.state === "completed";
    return /*#__PURE__*/React.createElement(ConditionalWrapper, {
      condition: isCompleted,
      wrapper: function wrapper(children) {
        return /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
          from: "medium"
        }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
          alignItems: "center",
          gapSpace: 0.5
        }, children));
      }
    }, /*#__PURE__*/React.createElement(StepAtm, _extends({
      key: step.title
    }, step)), index < steps.length - 1 ? /*#__PURE__*/React.createElement(IconAtm, {
      icon: CaretDownSvg,
      emphasis: isCompleted ? "low" : "extraLow",
      sizeSpace: 2
    }) : null);
  }));
};
export default StepsMol;